import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.136 6.268a.9.9 0 0 1 0 1.273l-4.463 4.464 4.463 4.463a.9.9 0 1 1-1.272 1.273l-5.1-5.1a.9.9 0 0 1 0-1.273l5.1-5.1a.9.9 0 0 1 1.272 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }